import React, { useContext } from 'react';
import { LanguageContext } from '../../shared/contexts/Language.context';
import { ThemeContext } from '../../shared/contexts/Theme.context';
import Loader from '../../shared/loaders/Loader';
import CustomIcon from '../CustomIcon/CustomIcon';

export default function BookingSearchLoader({ searchTitle }) {
  const {
    actions: { translate },
  } = useContext(LanguageContext);
  const { state: theme } = useContext(ThemeContext);
  return (
    <div id='search' className={'searching'}>
      <CustomIcon type={'hotel1'} size={257} color={theme.titleColor}></CustomIcon>
      <p className={'searching-title'}>{searchTitle || translate('bookingList.searching')}</p>
      <Loader></Loader>
      <style jsx>
        {`
          .searching {
            display: flex;
            flex-direction: column;
            margin-top: 40px;
          }

          .searching-title {
            color: ${theme.titleColor};
            padding: 30px 0px;
          }
        `}
      </style>
    </div>
  );
}
